import { Component } from 'react';
import ShowToast from '@/Components/Toast/showToastTemplate';
import { TOAST_TEXT_GENERAL_SPREADSHEET_ERROR, TOAST_TYPE_ERROR } from '@/Utils/constants';

export default class FilterPanelErrorBoundary extends Component {
  state = { hasError: false };

  componentDidCatch(error, errorInfo) {
    console.error('FilterPanel crashed:', error, errorInfo);

    // Close the modal immediately
    if (typeof this.props.onReset === 'function') {
      this.props.onReset();
    }

    // Show error toast
    ShowToast({
      type: TOAST_TYPE_ERROR,
      text: TOAST_TEXT_GENERAL_SPREADSHEET_ERROR,
      errorContext: error,
      fileAndFunction: '__FILE_AND_FUNCTION_NAME__',
    });

    // Mark that we've caught an error
    this.setState({ hasError: true });
  }

  componentDidUpdate(prevProps) {
    // Whenever `resetKey` (i.e. the `show` flag) toggles, clear the error
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      // swallow the entire panel so React doesn’t try to re-render the broken tree
      return null;
    }
    return this.props.children;
  }
}
